import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-purchase-confirm',
  templateUrl: './purchase-confirm.component.html',
  styleUrls: ['./purchase-confirm.component.scss']
})


export class PurchaseConfirmComponent implements OnInit {

  message: string;
  name: string;
  clicked = false;
  constructor(
    public dialog: MatDialogRef<PurchaseConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.message = data.message;
    this.name = data.name ? data.name : '';
  }

  ngOnInit(): void {
  }

  approve() {
    this.clicked = true;
    this.dialog.close(1);
  }

  deny() {
    this.clicked = true;
    this.dialog.close(2);
  }
  cancel() {
    this.clicked = true;
    this.dialog.close(0);
  }
}
